export function is_baga(company: string): boolean {
  const BAGA_STAGE = '2bd543db-c48f-4f99-b185-806a6f5a6b3d'
  const BAGA_PROD = '374d9b8d-731b-4f7c-82f5-db544fa0eae1'
  return company === BAGA_STAGE || company === BAGA_PROD
}

export function by_email(_company: string): boolean {
  return false
}

export function by_card(company: string): boolean {
  return is_baga(company)
}
